/** Hide No Pay on Apply summary when there is no taken days and pool is 0 / N/A. */
export function shouldHideNoPayFromApplySummary(item: {
  leaveType?: string;
  leavesTaken?: number;
  leavesAvailable?: number;
}): boolean {
  if (item?.leaveType !== 'No Pay Leave') {
    return false;
  }
  const taken = item.leavesTaken ?? 0;
  if (taken > 0) {
    return false;
  }
  const available = item.leavesAvailable ?? 0;
  return available <= 0;
}
